/**
 * Created by Daniel Wang on 2024-06-18.
 * Description:
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EntityAssociatedInfoGuard implements CanActivate {
    private _logoutTrigger = false;

    constructor(
        private _router: Router,
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        // If the previous URL was blank, then the user is directly accessing this page
        if (this._router.url === '/') {
            this._router.navigate(['entities']); // Navigate away to entity list page
            return false;
        }
        return true;
    }
}
